import {
    FETCH_COMMISSION_APPROVALS,
    FETCH_COMMISSION_DASHBOARD,
    FETCH_COMMISSION_DASHBOARD_ITEM,
    FETCH_COMMISSION_DASHBOARD_LEDGER,
    FETCH_COMMISSION_DASHBOARD_ADJUSTMENTS,
    FETCH_COMMISSION_DASHBOARD_PAYMENTS,
    FETCH_COMMISSION_DASHBOARD_UPCOMING,
    FETCH_COMMISSION_DASHBOARD_HOLDS,
    FETCH_COMMISSION_PAYOUT_HISTORY,
    FETCH_COMMISSION_PAYOUTS,
    FETCH_COMMISSION_PERIODS,
    FETCH_COMMISSION_RECONCILIATION,
} from '../actions/types';

const emptyDashboard = {
    filters: { employees: [] },
    summary: {},
    workflow: {},
};

const initialState = {
    dashboard: emptyDashboard,
    dashboardDetail: null,
    dashboardLedger: { data: [] },
    dashboardAdjustments: { data: [] },
    dashboardPayments: { data: [] },
    dashboardUpcoming: { data: [] },
    dashboardHolds: { data: [] },
    periods: { data: [] },
    reconciliation: { data: [] },
    approvals: { data: [] },
    payouts: { items: { data: [] }, eligibility: {} },
    payoutHistory: [],
};

export default function commissionReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_COMMISSION_DASHBOARD:
            return { ...state, dashboard: action.payload || emptyDashboard };
        case FETCH_COMMISSION_DASHBOARD_ITEM:
            return { ...state, dashboardDetail: action.payload || null };
        case FETCH_COMMISSION_DASHBOARD_LEDGER:
            return { ...state, dashboardLedger: action.payload || { data: [] } };
        case FETCH_COMMISSION_DASHBOARD_ADJUSTMENTS:
            return { ...state, dashboardAdjustments: action.payload || { data: [] } };
        case FETCH_COMMISSION_DASHBOARD_PAYMENTS:
            return { ...state, dashboardPayments: action.payload || { data: [] } };
        case FETCH_COMMISSION_DASHBOARD_UPCOMING:
            return { ...state, dashboardUpcoming: action.payload || { data: [] } };
        case FETCH_COMMISSION_DASHBOARD_HOLDS:
            return { ...state, dashboardHolds: action.payload || { data: [] } };
        case FETCH_COMMISSION_PERIODS:
            return { ...state, periods: action.payload || { data: [] } };
        case FETCH_COMMISSION_RECONCILIATION:
            return { ...state, reconciliation: action.payload || { data: [] } };
        case FETCH_COMMISSION_APPROVALS:
            return { ...state, approvals: action.payload || { data: [] } };
        case FETCH_COMMISSION_PAYOUTS:
            return { ...state, payouts: action.payload || { items: { data: [] }, eligibility: {} } };
        case FETCH_COMMISSION_PAYOUT_HISTORY:
            return { ...state, payoutHistory: action.payload || [] };
        default:
            return state;
    }
}
